import { render, staticRenderFns } from "./SurveyResult.vue?vue&type=template&id=230888f2&scoped=true&"
import script from "./SurveyResult.vue?vue&type=script&lang=js&"
export * from "./SurveyResult.vue?vue&type=script&lang=js&"
import style0 from "./SurveyResult.vue?vue&type=style&index=0&id=230888f2&scoped=true&lang=css&"
import style1 from "./SurveyResult.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230888f2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VContainer,VDialog})
